import { motion } from "framer-motion";
import { useLang } from "../../context/LangContext";
import "./ExperienceSection.css";

import logo1500 from "../../assets/Principal/1500fh_logo.jpg";
import logoQueroQuero from "../../assets/Principal/logo_queroquero.jpg";
import logoFesc from "../../assets/Principal/logo_fesc.jpg";

const typeColor = { work: "#10b981", extension: "#6366f1" };

// logos por índice (0=Luz,1=SantaCasa,2=1500,3=Embrapa,4=QueroQuero,5=FESC)
const logos = [null, null, logo1500, null, logoQueroQuero, logoFesc];
const logoInitials = ["LZ", "SC", "15", "EM", "QQ", "FE"];
const types = ["work", "extension", "work", "extension", "work", "work"];
const tags = ["current", "ongoing", null, "done", null, null];

const techs = [
  [
    "C#",
    ".NET",
    "PostgreSQL",
    "React",
    "TypeScript",
    "REST API",
    "BACEN",
    "Scrum",
    "SOLID",
  ],
  [
    "React",
    "Next.js",
    "TypeScript",
    "Java",
    "GitHub Projects",
    "Tech Lead",
    "Code Review",
  ],
  ["React", "Tailwind CSS", "C#", "JWT", "JUnit", "NUnit", "REST API", "Agile"],
  [
    "React",
    "Next.js",
    "TypeScript",
    "Java",
    "Scrum",
    "Tech Lead",
    "GitHub Projects",
  ],
  ["Web", "Figma", "Scrum", "UX/UI"],
  ["Ensino", "Programação", "Inclusão Digital", "Didática"],
];

export default function ExperienceSection() {
  const { t } = useLang();
  const e = t?.experience;
  const items = Array.isArray(e?.items) ? e.items : [];

  return (
    <section className="experience-section" id="experience">
      <div className="experience-container">
        <span className="experience-code">{e?.tag || 'Experience'}</span>
        <h1 className="experience-title">
          {e?.title || 'Experience'} <span className="experience-highlight">.</span>
        </h1>

        <div className="experience-timeline">
          {items.map((exp, idx) => {
            const type = types[idx];
            const color = typeColor[type];
            const tag = tags[idx];
            const logo = logos[idx];
            const initial = logoInitials[idx];

            return (
              <motion.div
                className="experience-row"
                key={idx}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.75, delay: idx * 0.08 }}
              >
                <div
                  className="experience-dot"
                  style={{ borderColor: color }}
                />

                <div className="experience-card">
                  <div className="experience-header">
                    {logo ? (
                      <img
                        src={logo}
                        alt={exp.company}
                        className="experience-logo"
                      />
                    ) : (
                      <div
                        className="experience-logo-initial"
                        style={{ borderColor: color + "55", color }}
                      >
                        {initial}
                      </div>
                    )}

                    <div className="experience-header-info">
                      <div className="experience-header-top">
                        <span className="experience-role">{exp.role}</span>
                        <div className="experience-badges-row">
                          <span
                            className="experience-type-badge"
                            style={{
                              background: color + "18",
                              color,
                              borderColor: color + "44",
                            }}
                          >
                            {e?.typeLabels?.[type] || type}
                          </span>
                          {tag && (
                            <span
                              className="experience-status-badge"
                              style={{
                                background:
                                  tag !== "done" ? "#10b98118" : "#ffffff10",
                                color: tag !== "done" ? "#10b981" : "#aaa",
                                borderColor:
                                  tag !== "done" ? "#10b98144" : "#ffffff20",
                              }}
                            >
                              {tag !== "done" && (
                                <span className="experience-pulse" />
                              )}
                              {e?.tags?.[tag] || tag}
                            </span>
                          )}
                        </div>
                      </div>
                      <span className="experience-company">
                        @ {exp.company}
                      </span>
                      <div className="experience-meta-row">
                        <span className="experience-period">{exp.period}</span>
                        <span className="experience-dot-sep">·</span>
                        <span className="experience-location">
                          {exp.location}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="experience-summary">
                    {exp.summary}
                    {exp.bullets && (
                      <ul className="experience-bullets">
                        {exp.bullets.map((b, i) => (
                          <li key={i}>{b}</li>
                        ))}
                      </ul>
                    )}
                  </div>

                  <div className="experience-techs">
                    {(techs[idx] || []).map((tech, i) => (
                      <span className="experience-tech-badge" key={i}>
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
